import { getAccHostname } from '@adsk/acs-sc-web-platform-api';

export const buildProductMemberUrl = (projectId, productId) => {
  return `${getAccHostname()}/${productId}/members/projects/${projectId}`;
};
